export type Channel = "sms" | "email" | "whatsapp";
export type SenderType = "hotel" | "staff";
export type BookingAfterUnit = "minutes" | "hours";

export type StaffOption = {
  id: string;
  name: string;
  role: string;
  phone: string;
  initials: string;
};

export enum MessagingSettingsTab {
  ARRIVAL = "arrival",
  BOOKING = "booking",
  EMAIL_TEMPLATES = "email-templates",
}
